import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import PageHero from "../components/PageHero";
import { aboutSections, siteMeta } from "../data/siteContent";

function AboutPage() {
  return (
    <>
      <PageHero
        eyebrow="About"
        title="Rooted in the Word. Centered on Christ. Sent with the Gospel."
        intro="We want to be a church marked by theological depth, Christian warmth, gospel clarity, and everyday faithfulness."
        metaTitle={`About | ${siteMeta.churchName}`}
      />
      <section className="site-section">
        <Container>
          <Row className="g-4">
            {aboutSections.map((section) => (
              <Col md={6} key={section.title}>
                <article className="content-panel h-100">
                  <h2>{section.title}</h2>
                  <p>{section.text}</p>
                </article>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default AboutPage;
